import { Component } from '@angular/core';

@Component({
  selector: 'app-download-button-loader',
  templateUrl: './download-button-loader.component.html',
  styleUrls: ['./download-button-loader.component.scss']
})
export class DownloadButtonLoaderComponent {

}
